import { Caption, Flex, useStyles } from '@archipro-design/aria';
import * as S from './ImageCaption.style';
import parse from 'html-react-parser';

interface ImageCaptionProps {
    text: string;
    isMain?: boolean;
}

const ImageCaption = ({ text, isMain }: ImageCaptionProps) => {
    const { css } = useStyles();
    const captionStyle = isMain
        ? S.TagMainCaptionContainer
        : S.TagSubCaptionContainer;
    const captionAsReactElements = parse(text);

    return (
        <Flex className={css(captionStyle)}>
            <Caption variant="03-alt">{captionAsReactElements}</Caption>
        </Flex>
    );
};

export default ImageCaption;
